import { useContext } from "react"
import { AppContext, Shape } from "../../../context/context"

export function useSelectElement(shapeData: Shape) {
    const context = useContext(AppContext);
    
    if (!context) {
        throw new Error("useSelectElement must be used within the AppContext provider")
    }

    const { global } = context;

    return (e: React.MouseEvent<HTMLButtonElement | HTMLDivElement>): void => {
        const isSelected = global.selectedShapes.includes(shapeData.id)
        const isCTRL = e.ctrlKey
        const numberOfSelectedShapes = global.selectedShapes.length
        const setFunc = global.setSelectedShapes

        // if nothing in list - add it to list (i.e. if nothing is selected)
        if (numberOfSelectedShapes === 0) {
            setFunc(prev => [shapeData.id])
            return
        }

        if (isSelected && !isCTRL) {
            // you've clicked a selected point without holding ctrl
            if (numberOfSelectedShapes === 1) {
                // if it is the only thing selected, de-select that point, i.e. remove it from the list
                setFunc(prev => [])
                return
            } else if (numberOfSelectedShapes > 1) {
                // if there are multiple things selected, de-select the rest and only select this
                setFunc(prev => [shapeData.id])
                return
            }

            throw new Error("Something has gone wrong in the selectElement function - isSelected && !isCTRL")
        }

        if (isSelected && isCTRL) {
            if (numberOfSelectedShapes > 1) {
                // if multiple things selected, you're holding ctrl and you click this item - de-select it, keep the rest
                setFunc(prev => prev.filter(item => item !== shapeData.id))
                return
            } else {
                // if there is only one thing selected and we hold control and click that same thing - do nothing.
                return
            }
        }

        if (!isSelected && !isCTRL) {
            // if it isn't selected and we aren't holding ctrl, select that item and nothing else
            setFunc(prev => [shapeData.id])
            return
        }

        if (!isSelected && isCTRL) {
            // if it isn't in the list and we are holding CTRL - add it to the list of selected points
            setFunc(prev => [...prev, shapeData.id])
            return
        }

        throw new Error("James is lazy and if this error is thrown in selectElement - then he has messed up")
    }
}